export default "__VITE_ASSET__C6r1wdN0__"